import AppsContainer from "@lib/components/AppComponents/AppsContainer";
import { StyledCollapse } from "@lib/components/StyledComponents";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import LogDetail from "./LogDetail";
import { useAuditLogQueries } from "@lib/apiQueries";

export default function AuditLogDetail() {
  const { messages } = useIntl();
  const { auditLogId } = useParams();

  const { auditLogQuery } = useAuditLogQueries({
    id: auditLogId,
    enabled: !!auditLogId,
    messages,
    params: {
      id: auditLogId,
      join: ["manager"],
    },
  });
  const { data, isLoading, isFetching } = auditLogQuery;
  const apiData = data?.data;

  return (
    <AppsContainer
      fullView={true}
      cardBg
      isLoading={isLoading || isFetching}
      title={messages["common.detail"] as string}
    >
      <StyledCollapse
        defaultActiveKey={"1"}
        items={[
          {
            key: "1",
            label: "Details",
            children: <LogDetail data={apiData} />,
          },
          // {
          //   key: "2",
          //   label: "TimeLine",
          //   children: <>test</>,
          // },
        ]}
      />
    </AppsContainer>
  );
}
